export default __webpack_public_path__ + "static/media/mo-parteners-digi-connect-l1.e0171dc9.png";